exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.el-input-number[data-v-2090d4a5] .el-input__inner {\n  text-align: center;\n  /* 将数字内容右对齐 */\n}\n.is-error[data-v-2090d4a5] .el-input-number__decrease,\n.is-error[data-v-2090d4a5] .el-input-number__increase,\n.is-success[data-v-2090d4a5] .el-input-number__decrease,\n.is-success[data-v-2090d4a5] .el-input-number__increase {\n  right: 1px !important;\n}\n", ""]);

// exports
